angular.
module("dx.webapp.jobs").
constant("DX_JOB_ORIGIN", Object.freeze({
	INTERNAL: "internal",
	EXTERNAL: "external",
}));
